
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { fadeInOut } from '@shared/src/animations';


@Component({
  selector: 'shared-deleteobject',
  templateUrl: './shared.deleteobject.component.html',
  styleUrls: ['./shared.deleteobject.component.scss'],
  animations: [fadeInOut]
})
export class SharedDeleteObjectComponent {

  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Output() onCancelDelete: EventEmitter<any> = new EventEmitter();

  @Input() value: any;

  public deletetitle() {
    return "GENERAL.DELETE.CAPTION";
  }
  public click() {
    this.onDelete.next(this.value);
  }
  public clickCancelZone() {
    this.onCancelDelete.next(this.value);
  }
}
